import { createContext } from "react";

const configContext = createContext();

export default configContext;
